<!--
  Copyright (C) 2021 owner Roman Piontik R.Piontik@mail.ru

  Copyright (C) 2022 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      R.Piontik <r.piontik@mail.ru>

  Contributors:
      R.Piontik <r.piontik@mail.ru> - 2021
      R.Piontik <r.piontik@mail.ru> - 2022
      R.Piontik <r.piontik@mail.ru> - 2023
-->

<template>
  <box>
    <plantuml v-if="uml" v-bind:uml="uml" v-bind:context-menu="contextMenu" />
  </box>
</template>

<script>
  import mustache from 'mustache';

  import Plantuml from '@front/components/Schema/PlantUML.vue';
  import requests from '@front/helpers/requests';

  import DocMixin from './DocMixin';

  export default {
    name: 'DocPlantUML',
    components: {
      Plantuml
    },
    mixins: [DocMixin],
    data() {
      return {
        content: ''
      };
    },
    asyncComputed: {
      async uml() {
        let result = '';
        if (this.isTemplate) {
          this.source.dataset && (result = mustache.render(this.content, this.source.dataset));
        } else result = this.content;
        return result;
      }
    },
    methods: {
      refresh() {
        this.content = '';
        requests.request(this.url).then((response) => {
          this.content = response.data.toString();
        }).catch((e) => this.error = e);
        this.sourceRefresh();
      }
    }
  };
</script>

<style>

</style>
